import { Component, Input, EventEmitter, Output } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AuthenticationStorage } from '../../../core/authentication/authentication-storage.service';
import { ErrorService } from '../../../core/error/error.service';



/**
   * Logger Factory
*/

@Component({
  selector: 'ute-header',
  templateUrl: 'ute-header.component.html'
})
export class UteHeaderComponent  {

  @Input() items: any;
  @Input() showBack: boolean;
  @Input() titleBack: any;
  @Input() linkBack: any;
  @Output() onClickItem = new EventEmitter;
  public isOpen: boolean = false;
  

  constructor(
    private navCtrl: NavController,
    private auth: AuthenticationStorage,
    private error: ErrorService
  ) {

  }

  onClickItemMenu(value){
    this.onClickItem.emit(value);
    this.auth.deleteAll();
    this.error.addError(null);
  }

  goToPreviousPage(){
    this.navCtrl.push(this.linkBack);
    this.error.addError(null);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/molecules/ute-header/ute-header.component.ts